"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetSimilarProductsUseCase = void 0;
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const useIsSimilarProductsEnabled_1 = require("../../hooks/useIsSimilarProductsEnabled");
const favorites_1 = require("../../providers/favorites");
const query_1 = require("../../providers/query");
const products_1 = require("../../services/products");
const tdcClient_1 = require("../../services/tdcClient");
const getSimilarProductsSkus_usecase_1 = require("./getSimilarProductsSkus.usecase");
/**
 * Caso de uso que obtém as opções de produto similares para determinados SKUs,
 * já enriquecidos com as informações de produto.
 */
function useGetSimilarProductsUseCase({ skus, businessUnit, resellerSlug, queryContext = favorites_1.favoritesQueryClientContext, }) {
    const [queryEnabled, setQueryEnabled] = (0, react_1.useState)(false);
    const isSimilarProductsEnabled = (0, useIsSimilarProductsEnabled_1.useIsSimilarProductsEnabled)(resellerSlug);
    const initialData = { facets: [], count: 0, products: [] };
    const productsService = (0, react_1.useMemo)(() => new products_1.ProductsService(tdcClient_1.tdcClient), []);
    const [similarProductsSkus, getSimilarProductsSkus] = (0, getSimilarProductsSkus_usecase_1.useGetSimilarProductsSkusUseCase)({
        skus,
        resellerSlug,
        businessUnit,
    });
    const skusToBeEnhanced = (0, react_1.useMemo)(() => Object.values(similarProductsSkus).reduce((acc, item) => acc.concat(item.map((s) => s.sku)), []), [similarProductsSkus]);
    const { data: similarProductsItems } = (0, react_query_1.useQuery)({
        queryKey: query_1.ProductQueryKeys.GetBySkus(skusToBeEnhanced),
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            if (skusToBeEnhanced.length === 0) {
                return initialData;
            }
            return yield productsService.getProductsBySkus({
                skus: skusToBeEnhanced,
                businessUnit,
                page: 1,
                pageSize: skusToBeEnhanced.length,
                catalogSlug: resellerSlug,
            });
        }),
        initialData,
        select: (getProductResponse) => createEnhancedSimilarProductsMap(getProductResponse, similarProductsSkus),
        enabled: queryEnabled,
        context: queryContext,
    });
    const call = () => {
        setQueryEnabled(true);
    };
    (0, react_1.useEffect)(() => {
        if (isSimilarProductsEnabled && skus.length) {
            getSimilarProductsSkus();
        }
    }, [isSimilarProductsEnabled, skus.length]);
    return [similarProductsItems, call];
}
exports.useGetSimilarProductsUseCase = useGetSimilarProductsUseCase;
function createEnhancedSimilarProductsMap(getProductsResponse, similarProductsSkus) {
    const similarProductsMap = new Map();
    Object.entries(similarProductsSkus).forEach(([key, value]) => {
        const composedValue = {
            similarProducts: enhanceWithProductResponse(value, getProductsResponse),
        };
        similarProductsMap.set(key, composedValue);
    });
    return Object.fromEntries(similarProductsMap);
}
function enhanceWithProductResponse(similarProducts, getProductsResponse) {
    return similarProducts
        .map((similarProduct) => matchSimilarWithProductItem(similarProduct, getProductsResponse.products))
        .filter(isNotNull);
}
function isNotNull(value) {
    return value != null;
}
function matchSimilarWithProductItem(similarProduct, products) {
    return products.find((p) => p.sku === similarProduct.sku);
}
